import { render, staticRenderFns } from "./DraftPriceIdleRouteAdd.vue?vue&type=template&id=dbccc96a&"
import script from "./DraftPriceIdleRouteAdd.vue?vue&type=script&lang=js&"
export * from "./DraftPriceIdleRouteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports